import { PaymentStatus } from '@bca-confirmation/models/_enums';
import { ITransaction } from '@bca-confirmation/models/transaction';
import { IAction } from '@bca-store/models/action';

export enum ConfirmationActionTypes {
  StartPayment = '[Confirmation] StartPayment',
  StartPaymentLoading = '[Confirmation] StartPaymentLoading',
  StatusPayment = '[Confirmation] StatusPayment',
  RedirectToIssuerLoading = '[Confirmation] RedirectToIssuerLoading',
  StatusPaymentLoading = '[Confirmation] StatusPaymentLoading',
  SetTransaction = '[Confirmation] SetTransaction',
  SetPaymentStatus = '[Confirmation] SetPaymentStatus',
  SetReferenceNumber = '[Confirmation] SetReferenceNumber',
  SetPurchaseEventSent = '[Confirmation] SetPurchaseEventSent', 
}

export class StartPayment implements IAction {
  readonly type = ConfirmationActionTypes.StartPayment;
}

export class StatusPayment implements IAction {
  readonly type = ConfirmationActionTypes.StatusPayment;
}

export class SetPurchaseEventSent implements IAction {
  readonly type = ConfirmationActionTypes.SetPurchaseEventSent;
  constructor(public readonly payload: { avoCapiPurchaseEvent: boolean }) {}
}

export class SetPaymentStatus implements IAction {
  readonly type = ConfirmationActionTypes.SetPaymentStatus;
  constructor(public readonly payload: { status: PaymentStatus }) {}
}

export class SetReferenceNumber implements IAction {
  readonly type = ConfirmationActionTypes.SetReferenceNumber;
  constructor(public readonly payload: { referenceNumber: string }) {}
}

export class SetTransaction implements IAction {
  readonly type = ConfirmationActionTypes.SetTransaction;
  constructor(public readonly payload: ITransaction) {}
}

export class StartPaymentLoading implements IAction {
  readonly type = ConfirmationActionTypes.StartPaymentLoading;
  constructor(
    public readonly payload: {
      loading: boolean;
    }
  ) {}
}

export class RedirectToIssuerLoading implements IAction {
  readonly type = ConfirmationActionTypes.RedirectToIssuerLoading;
  constructor(
    public readonly payload: {
      loading: boolean;
    }
  ) {}
}

export class StatusPaymentLoading implements IAction {
  readonly type = ConfirmationActionTypes.StatusPaymentLoading;
  constructor(
    public readonly payload: {
      loading: boolean;
    }
  ) {}
}

export class TriggerAvoPurchaseEvent implements IAction {
  readonly type = ConfirmationActionTypes.RedirectToIssuerLoading;
  constructor(
    public readonly payload: {
      avoCapiPurchaseEvent: boolean;
    }
  ) {}
}

export type Action =
  | StartPayment
  | StartPaymentLoading
  | StatusPaymentLoading
  | RedirectToIssuerLoading
  | SetTransaction
  | StatusPayment
  | SetPaymentStatus
  | SetReferenceNumber
  | SetPurchaseEventSent;
